<div class="core-edit-max-width">
  <div class="flex-row-space-between">
    <h1>Display Typ erstellen</h1>
  </div>

  <form [formGroup]="form">
    <core-input-text
      id="name"
      label="Name"
      formControlName="name"
      [disabled]="!userCanEdit">
    </core-input-text>

    <core-input-text
      id="code"
      label="Code"
      formControlName="code"
      [disabled]="!userCanEdit">
    </core-input-text>

    <core-button-submit
      *ngIf="userCanEdit"
      (click)="save()"
      [disabled]="form.invalid"
      [width]="'48%'">
    </core-button-submit>

    <div *ngIf="error" class="mt-2 alert alert-danger">{{ error }}</div>
  </form>
</div>
